import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full flex items-baseline justify-between" }
const _hoisted_3 = { class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold mb-1" }
const _hoisted_4 = {
  key: 0,
  title: "obligatorisk"
}
const _hoisted_5 = ["placeholder", "value", "required", "disabled"]
const _hoisted_6 = {
  key: 0,
  class: "text-red-2 mt-2"
}



export default /*@__PURE__*/_defineComponent({
  __name: 'BaseInput',
  props: {
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  keyId: String,

  modelValue: {
    type: String,
    default: "",
  },
  maxLength: {
    type: Number,
    required: false,
  },
  required: {
    type: Boolean,
    required: false,
    default: false,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  error: {
    type: Boolean,
    required: false,
    default: false,
  },
  errorMessage: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: ["update:modelValue"],
  setup(__props) {



const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _createTextVNode(_toDisplayString(props.label) + " ", 1),
        (props.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
          : _createCommentVNode("", true)
      ]),
      (
          props.maxLength > 0 && props.maxLength - props.modelValue.length < 10
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["text-xs text-darkGray-3", {
          'text-red-2': props.maxLength - props.modelValue.length < 0,
        }])
          }, _toDisplayString(props.maxLength ? props.modelValue.length + "/" + props.maxLength : ""), 3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("input", _mergeProps({
      class: ["appearance-none block w-full bg-blue-4 text-darkGray-1 placeholder-darkGray-4 border border-blue-4 rounded py-3 px-4 leading-tight focus:bg-white focus:border-blue-1 disabled:bg-gray-2 disabled:text-darkGray-2 disabled:cursor-not-allowed", {
        'border-red-2': props.error,
      }],
      type: "text",
      placeholder: props.placeholder,
      value: props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)
      ))
    }, _ctx.$attrs, {
      required: props.required ? true : null,
      disabled: props.disabled ? true : null
    }), null, 16, _hoisted_5),
    (props.errorMessage)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(props.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})